import { useInfoBlockData } from "Pages/BusinessLogistics/Analytics/Page/@hooks"
import { REQUEST_TYPE } from "Pages/BusinessLogistics/Analytics/Page/@constants"
import React from "react"
import { AppAnalyticsCard } from "@components"

export default function EuropcarDateRangeSearchesCard() {

	const { res, isLoading } = useInfoBlockData(REQUEST_TYPE.RANGE, true)

	const { searches } = res

	return <AppAnalyticsCard isLoading={isLoading} countUp={searches} label="Date Range" icon={"calendar-range"} iconColor={"colors.green"}/>

}